import React, { useState, useEffect } from 'react'
import {
  CheckboxColor,
  CheckboxUnit,
  Checkboxs,
  DBFilterCheckboxArea,
  DBFilterDateArea,
  DBFilterWrapper,
  DateArea,
  GotoStatus,
  DBTableExcelBtn
} from './styles';
import {Checkbox, Input, ConfigProvider, DatePicker, Select, Upload, message} from 'antd';
import { useStatusList } from 'CRM/hooks/GetStatusList';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import locale from "antd/lib/locale/ko_KR";
import { Icon } from '../Main/styles';
import { IoSearch } from "react-icons/io5";
import { RangePickerProps } from 'rc-picker/es/RangePicker.d';
import {FaArrowRotateRight, FaRegFileExcel} from "react-icons/fa6";
import { useHistory } from 'react-router-dom';
import API from "../../../utils/api";
import {useMyInfo} from "../../hooks/GetMyInfo";
import {useToken} from "../../../app/hooks";
import {useIsMobile} from "../../components/IsMobile";

const { RangePicker } = DatePicker;

export const DBFilter = ({
  pathList,
  resList,
  teamList,
  createdAt,
  setCreatedAt,
  assignedAt,
  setAssignedAt,
  updatedAt,
  setUpdatedAt,
  name,
  setName,
  tel,
  setTel,
  path,
  setPath,
  respon,
  setRespon,
  team,
  setTeam,
  selectedRows,
  setSelectedRows,
}) => {
  useEffect(() => {
    setInputName(name)
    setInputTel(tel)
    setInputPath(path)
    setInputRes(respon)
    setInputTeam(team)
    setInputCreated([createdAt?.[0], createdAt?.[1]])
    setInputAssigned([assignedAt?.[0], assignedAt?.[1]])
    setInputUpdated([updatedAt?.[0], updatedAt?.[1]])
    setInputSelectedRows(selectedRows)
  }, [name, tel, path, respon, team, selectedRows, createdAt, assignedAt, updatedAt])
  const { statusList } = useStatusList();
  const navigate = useHistory();
  const [inputName, setInputName] = useState(name);
  const [inputTel, setInputTel] = useState(tel);
  const [inputPath, setInputPath] = useState(path);
  const [inputRes, setInputRes] = useState(respon);
  const [inputTeam, setInputTeam] = useState(team);
  const [inputCreated, setInputCreated] = useState<RangePickerProps<dayjs.Dayjs>['value'] | any>([null, null]);
  const [inputAssigned, setInputAssigned] = useState<RangePickerProps<dayjs.Dayjs>['value'] | any>([null, null]);
  const [inputUpdated, setInputUpdated] = useState<RangePickerProps<dayjs.Dayjs>['value'] | any>([null, null]);
  const [inputSelectedRows, setInputSelectedRows] = useState<number[]>(selectedRows);

  const { myInfo } = useMyInfo();
  const { data: token } = useToken();
  const [upload, setUpload] = useState<any>('');

  const IsMobile = useIsMobile();

  const clickSearch = () => {
    const createdStart = inputCreated?.[0] ? dayjs(inputCreated?.[0]) : null;
    const createdEnd = inputCreated?.[1] ? dayjs(inputCreated?.[1]) : null;

    const assignedStart = inputAssigned?.[0] ? dayjs(inputAssigned?.[0]) : null;
    const assignedEnd = inputAssigned?.[1] ? dayjs(inputAssigned?.[1]) : null;
  
    const updatedStart = inputUpdated?.[0] ? dayjs(inputUpdated?.[0]) : null;
    const updatedEnd = inputUpdated?.[1] ? dayjs(inputUpdated?.[1]) : null;
  
    setCreatedAt([createdStart, createdEnd]);
    setAssignedAt([assignedStart, assignedEnd]);
    setUpdatedAt([updatedStart, updatedEnd]);
    setName(inputName);
    setTel(inputTel);
    setPath(inputPath);
    setRespon(inputRes);
    setTeam(inputTeam);
    setSelectedRows(inputSelectedRows);
  }
  
  const clickReset = () => {
    setCreatedAt([null, null])
    setAssignedAt([null, null])
    setUpdatedAt([null, null])
    setName('')
    setTel('')
    setPath('')
    setRespon('')
    setTeam('')
    setSelectedRows([])
  }

  const handleCheckboxChange = (e, id) => {
    if (e.target.checked) {
      setInputSelectedRows([...inputSelectedRows, id]);
    } else {
      setInputSelectedRows(inputSelectedRows?.filter(rowId => rowId !== id));
    }
  };

  return (
    <>
      {IsMobile ?
        <DBFilterWrapper style={{marginBottom: 20}}>
          <DBFilterCheckboxArea>
            <Checkboxs IsMobile={IsMobile}>
              {statusList?.map(it => (
                <CheckboxUnit>
                  <Checkbox key={it.id} id={it.id}  checked={inputSelectedRows?.includes(it.id)} onChange={(e) => handleCheckboxChange(e, it?.id)} />
                  <CheckboxColor style={{backgroundColor: it?.color}} />
                  <label htmlFor={it.id}>{it.name}</label>
                </CheckboxUnit>
              ))}
            </Checkboxs>
          </DBFilterCheckboxArea>
          <GotoStatus IsMobile={IsMobile} onClick={() => navigate.push('/admin/status')}>상태관리목록</GotoStatus>
          <DBFilterDateArea>
            <DateArea>
              <label htmlFor='createdAt'>등록일</label>
              <ConfigProvider locale={locale}>
                <RangePicker
                  id='createdAt'
                  value={inputCreated}
                  onChange={(values) => setInputCreated(values)}
                />
              </ConfigProvider>
            </DateArea>
          </DBFilterDateArea>

          <DBFilterDateArea>
            <DateArea>
              <label htmlFor='createdAt'>배정일</label>
              <ConfigProvider locale={locale}>
                <RangePicker
                  id='createdAt'
                  value={inputAssigned}
                  onChange={(values) => setInputAssigned(values)}
                />
              </ConfigProvider>
            </DateArea>
          </DBFilterDateArea>

          <DBFilterDateArea>
            <DateArea>
              <label htmlFor='createdAt'>수정일</label>
              <ConfigProvider locale={locale}>
                <RangePicker
                  id='createdAt'
                  value={inputUpdated}
                  onChange={(values) => setInputUpdated(values)}
                />
              </ConfigProvider>
            </DateArea>
          </DBFilterDateArea>

          <DBFilterDateArea>
              <DateArea>
                <label htmlFor='name'>고객명</label>
                <Input type='text' id='name' value={inputName} onChange={(e) => setInputName(e.target.value)} placeholder='고객명 검색 입력' />
              </DateArea>
          </DBFilterDateArea>

          <DBFilterDateArea>
            <DateArea>
              <label htmlFor='tel'>연락처</label>
              <Input type='text' id='tel' value={inputTel} onChange={(e) => setInputTel(e.target.value)} placeholder='연락처 검색 입력' />
            </DateArea>
          </DBFilterDateArea>

          <DBFilterDateArea>
            <DateArea>
              <label htmlFor='name'>방문경로</label>
              <Select value={inputPath} onChange={(e) => setInputPath(e)}>
                <option style={{fontFamily: 'Pretendard'}} value={''}>--</option>
                {pathList?.map(it => (
                  <option style={{fontFamily: 'Pretendard'}} value={it.name}>{it.name}</option>
                ))}
              </Select>
            </DateArea>
          </DBFilterDateArea>

          <DBFilterDateArea>
            <DateArea>
              <label htmlFor='name'>담당자</label>
              <Select value={inputRes} onChange={(e) => setInputRes(e)}>
                <option style={{fontFamily: 'Pretendard'}} value={''}>--</option>
                {resList?.map(it => (
                  <option style={{fontFamily: 'Pretendard'}} value={it.name}>{it.name}</option>
                ))}
              </Select>
            </DateArea>
          </DBFilterDateArea>


          <DBFilterDateArea>
            <DateArea>
              <label htmlFor='name'>팀별</label>
              <Select value={inputTeam} onChange={(e) => setInputTeam(e)}>
                <option style={{fontFamily: 'Pretendard'}} value={''}>--</option>
                {teamList?.map(it => (
                  <option style={{fontFamily: 'Pretendard'}} value={it.name}>{it.name}</option>
                ))}
              </Select>
            </DateArea>
          </DBFilterDateArea>

          <DBFilterDateArea>
            <GotoStatus onClick={clickSearch} style={{backgroundColor: '#26DAD1'}}>
              <Icon><IoSearch /></Icon>
              검색
            </GotoStatus>
            <GotoStatus onClick={clickReset} style={{backgroundColor: '#5c636a'}}>
              <Icon><FaArrowRotateRight /></Icon>
              초기화
            </GotoStatus>
          </DBFilterDateArea>

          <DBFilterDateArea>
            {myInfo.master && (
              <>
                <Upload
                  onChange={(fileList: any) => {
                    setUpload(fileList)
                  }}>
                  파일선택
                </Upload>
                <DBTableExcelBtn
                  onClick={() => {

                    if (upload?.fileList === undefined) {
                      message.error('파일을 선택해주세요')
                      return
                    }

                    const targetFilesArrayLogo = Array.from(upload.fileList)
                    const formData = new FormData()


                    if (upload?.fileList?.length === 0) {
                      message.error('파일을 선택해주세요')
                      return
                    }

                    targetFilesArrayLogo.forEach((file: any) => {
                      if (file.originFileObj) {
                        formData.append('file', file.originFileObj)
                      }
                    })

                    API.postImage('POST', '/user/excelupload', token + '', formData)
                      .then((res: any) => {
                        if (res.result.success) {
                          message.success('등록되었습니다')
                        } else {
                          message.error('파일이 잘못되었습니다')
                        }
                      })
                      .catch((err: any) => {})
                  }}
                  style={{ backgroundColor: '#437eff', color: '#fff' }}>
                  <Icon>
                    <FaRegFileExcel />
                  </Icon>
                  엑셀등록
                </DBTableExcelBtn>
              </>
            )}
          </DBFilterDateArea>
        </DBFilterWrapper>
        :
        <DBFilterWrapper>
          <DBFilterCheckboxArea>
            <Checkboxs>
              {statusList?.map(it => (
                <CheckboxUnit>
                  <Checkbox key={it.id} id={it.id}  checked={inputSelectedRows?.includes(it.id)} onChange={(e) => handleCheckboxChange(e, it?.id)} />
                  <CheckboxColor style={{backgroundColor: it?.color}} />
                  <label htmlFor={it.id}>{it.name}</label>
                </CheckboxUnit>
              ))}
            </Checkboxs>
            <GotoStatus onClick={() => navigate.push('/admin/status')}>상태관리목록</GotoStatus>
          </DBFilterCheckboxArea>
          <DBFilterDateArea>
            <DateArea>
              <label htmlFor='createdAt'>등록일</label>
              <ConfigProvider locale={locale}>
                <RangePicker
                  id='createdAt'
                  value={inputCreated}
                  onChange={(values) => setInputCreated(values)}
                />
              </ConfigProvider>
            </DateArea>
            <DateArea>
              <label htmlFor='createdAt'>배정일</label>
              <ConfigProvider locale={locale}>
                <RangePicker
                  id='createdAt'
                  value={inputAssigned}
                  onChange={(values) => setInputAssigned(values)}
                />
              </ConfigProvider>
            </DateArea>
            <DateArea>
              <label htmlFor='createdAt'>수정일</label>
              <ConfigProvider locale={locale}>
                <RangePicker
                  id='createdAt'
                  value={inputUpdated}
                  onChange={(values) => setInputUpdated(values)}
                />
              </ConfigProvider>
            </DateArea>
          </DBFilterDateArea>
          <DBFilterDateArea>
            <>
              <DateArea>
                <label htmlFor='name'>고객명</label>
                <Input type='text' id='name' value={inputName} onChange={(e) => setInputName(e.target.value)} placeholder='고객명 검색 입력' />
              </DateArea>
              <DateArea>
                <label htmlFor='tel'>연락처</label>
                <Input type='text' id='tel' value={inputTel} onChange={(e) => setInputTel(e.target.value)} placeholder='연락처 검색 입력' />
              </DateArea>
              <DateArea>
                <label htmlFor='name'>방문경로</label>
                <Select value={inputPath} onChange={(e) => setInputPath(e)}>
                  <option style={{fontFamily: 'Pretendard'}} value={''}>--</option>
                  {pathList?.map(it => (
                    <option style={{fontFamily: 'Pretendard'}} value={it.name}>{it.name}</option>
                  ))}
                </Select>
              </DateArea>
              <DateArea>
                <label htmlFor='name'>담당자</label>
                <Select value={inputRes} onChange={(e) => setInputRes(e)}>
                  <option style={{fontFamily: 'Pretendard'}} value={''}>--</option>
                  {resList?.map(it => (
                    <option style={{fontFamily: 'Pretendard'}} value={it.name}>{it.name}</option>
                  ))}
                </Select>
              </DateArea>
              <DateArea>
                <label htmlFor='name'>팀별</label>
                <Select value={inputTeam} onChange={(e) => setInputTeam(e)}>
                  <option style={{fontFamily: 'Pretendard'}} value={''}>--</option>
                  {teamList?.map(it => (
                    <option style={{fontFamily: 'Pretendard'}} value={it.name}>{it.name}</option>
                  ))}
                </Select>
              </DateArea>
            </>
            <GotoStatus onClick={clickSearch} style={{backgroundColor: '#26DAD1'}}>
              <Icon><IoSearch /></Icon>
              검색
            </GotoStatus>
            <GotoStatus onClick={clickReset} style={{backgroundColor: '#5c636a'}}>
              <Icon><FaArrowRotateRight /></Icon>
              초기화
            </GotoStatus>

            {myInfo.master && (
              <>
                <Upload
                  onChange={(fileList: any) => {
                    setUpload(fileList)
                  }}>
                  파일선택
                </Upload>
                <DBTableExcelBtn
                  onClick={() => {

                    if (upload?.fileList === undefined) {
                      message.error('파일을 선택해주세요')
                      return
                    }

                    const targetFilesArrayLogo = Array.from(upload.fileList)
                    const formData = new FormData()


                    if (upload?.fileList?.length === 0) {
                      message.error('파일을 선택해주세요')
                      return
                    }

                    targetFilesArrayLogo.forEach((file: any) => {
                      if (file.originFileObj) {
                        formData.append('file', file.originFileObj)
                      }
                    })

                    API.postImage('POST', '/user/excelupload', token + '', formData)
                      .then((res: any) => {
                        if (res.result.success) {
                          message.success('등록되었습니다')
                        } else {
                          message.error('파일이 잘못되었습니다')
                        }
                      })
                      .catch((err: any) => {})
                  }}
                  style={{ backgroundColor: '#437eff', color: '#fff' }}>
                  <Icon>
                    <FaRegFileExcel />
                  </Icon>
                  엑셀등록
                </DBTableExcelBtn>
              </>
            )}
          </DBFilterDateArea>
          <DBFilterDateArea>

          </DBFilterDateArea>
        </DBFilterWrapper>
      }
    </>


  )
}

export default React.memo(DBFilter);